const COMPONENT_NAME = "WarehouseDrawer";
const SEARCH_FIELD_MAX_LENGTH = 50;
const BATCH_SIZE_MAX = 3;
const IS_SHOWROOM_LOCATION = "hs";
export {
  BATCH_SIZE_MAX,
  COMPONENT_NAME,
  IS_SHOWROOM_LOCATION,
  SEARCH_FIELD_MAX_LENGTH
};
